import {
  InsertionPredicate,
  CriteriaOrGroup,
  CriteriaEntry,
  StringPredicateValueMap,
} from '../types/insertionCriteria';

export const anyOf = (
  predicates: InsertionPredicate[],
  tooltipMessage: string
): CriteriaOrGroup => ({ anyOf: predicates, tooltipMessage });

export function maxDuration(maxMs: number): InsertionPredicate;
export function maxDuration(
  maxMs: number,
  tooltipMessage: string
): CriteriaEntry;
export function maxDuration(
  maxMs: number,
  tooltipMessage?: string
): InsertionPredicate | CriteriaEntry {
  const predicate: InsertionPredicate = {
    field: 'duration',
    op: 'LTE',
    value: maxMs,
  };
  return tooltipMessage !== undefined
    ? { predicate, tooltipMessage }
    : predicate;
}

export function minDuration(minMs: number): InsertionPredicate;
export function minDuration(
  minMs: number,
  tooltipMessage: string
): CriteriaEntry;
export function minDuration(
  minMs: number,
  tooltipMessage?: string
): InsertionPredicate | CriteriaEntry {
  const predicate: InsertionPredicate = {
    field: 'duration',
    op: 'GTE',
    value: minMs,
  };
  return tooltipMessage !== undefined
    ? { predicate, tooltipMessage }
    : predicate;
}

export function requireVideoType(
  type: StringPredicateValueMap['videoType']
): InsertionPredicate;
export function requireVideoType(
  type: StringPredicateValueMap['videoType'],
  tooltipMessage: string
): CriteriaEntry;
export function requireVideoType(
  type: StringPredicateValueMap['videoType'],
  tooltipMessage?: string
): InsertionPredicate | CriteriaEntry {
  const predicate: InsertionPredicate = {
    field: 'videoType',
    op: 'EQ',
    value: type,
  };
  return tooltipMessage !== undefined
    ? { predicate, tooltipMessage }
    : predicate;
}

export function requireVideoOrigin(
  origin: StringPredicateValueMap['videoOrigin']
): InsertionPredicate;
export function requireVideoOrigin(
  origin: StringPredicateValueMap['videoOrigin'],
  tooltipMessage: string
): CriteriaEntry;
export function requireVideoOrigin(
  origin: StringPredicateValueMap['videoOrigin'],
  tooltipMessage?: string
): InsertionPredicate | CriteriaEntry {
  const predicate: InsertionPredicate = {
    field: 'videoOrigin',
    op: 'EQ',
    value: origin,
  };
  return tooltipMessage !== undefined
    ? { predicate, tooltipMessage }
    : predicate;
}

export function requirePublicVideo(): InsertionPredicate;
export function requirePublicVideo(tooltipMessage: string): CriteriaEntry;
export function requirePublicVideo(
  tooltipMessage?: string
): InsertionPredicate | CriteriaEntry {
  const predicate: InsertionPredicate = {
    field: 'sourceFileAllowsAnonymousAccess',
    op: 'EQ',
    value: true,
  };
  return tooltipMessage !== undefined
    ? { predicate, tooltipMessage }
    : predicate;
}

export function requireAnyoneWithLinkVideo(): InsertionPredicate;
export function requireAnyoneWithLinkVideo(
  tooltipMessage: string
): CriteriaEntry;
export function requireAnyoneWithLinkVideo(
  tooltipMessage?: string
): InsertionPredicate | CriteriaEntry {
  const predicate: InsertionPredicate = {
    field: 'visibility',
    op: 'EQ',
    value: 'ANYONE_WITH_LINK',
  };
  return tooltipMessage !== undefined
    ? { predicate, tooltipMessage }
    : predicate;
}

export function minWidth(minPx: number): InsertionPredicate;
export function minWidth(minPx: number, tooltipMessage: string): CriteriaEntry;
export function minWidth(
  minPx: number,
  tooltipMessage?: string
): InsertionPredicate | CriteriaEntry {
  const predicate: InsertionPredicate = {
    field: 'width',
    op: 'GTE',
    value: minPx,
  };
  return tooltipMessage !== undefined
    ? { predicate, tooltipMessage }
    : predicate;
}

export function maxWidth(maxPx: number): InsertionPredicate;
export function maxWidth(maxPx: number, tooltipMessage: string): CriteriaEntry;
export function maxWidth(
  maxPx: number,
  tooltipMessage?: string
): InsertionPredicate | CriteriaEntry {
  const predicate: InsertionPredicate = {
    field: 'width',
    op: 'LTE',
    value: maxPx,
  };
  return tooltipMessage !== undefined
    ? { predicate, tooltipMessage }
    : predicate;
}

export function minHeight(minPx: number): InsertionPredicate;
export function minHeight(minPx: number, tooltipMessage: string): CriteriaEntry;
export function minHeight(
  minPx: number,
  tooltipMessage?: string
): InsertionPredicate | CriteriaEntry {
  const predicate: InsertionPredicate = {
    field: 'height',
    op: 'GTE',
    value: minPx,
  };
  return tooltipMessage !== undefined
    ? { predicate, tooltipMessage }
    : predicate;
}

export function maxHeight(maxPx: number): InsertionPredicate;
export function maxHeight(maxPx: number, tooltipMessage: string): CriteriaEntry;
export function maxHeight(
  maxPx: number,
  tooltipMessage?: string
): InsertionPredicate | CriteriaEntry {
  const predicate: InsertionPredicate = {
    field: 'height',
    op: 'LTE',
    value: maxPx,
  };
  return tooltipMessage !== undefined
    ? { predicate, tooltipMessage }
    : predicate;
}

export function requireFileExtension(extension: string): InsertionPredicate;
export function requireFileExtension(
  extension: string,
  tooltipMessage: string
): CriteriaEntry;
export function requireFileExtension(
  extension: string,
  tooltipMessage?: string
): InsertionPredicate | CriteriaEntry {
  const normalizedExtension = extension.toLowerCase().replace(/^\./, '');
  const predicate: InsertionPredicate = {
    field: 'fileExtension',
    op: 'EQ',
    value: normalizedExtension,
  };

  return tooltipMessage !== undefined
    ? { predicate, tooltipMessage }
    : predicate;
}
